module.exports = __webpack_public_path__ + "static/media/1.d2dee2c6.webp";